import { render, staticRenderFns } from "./EventModalDocumentsActs.vue?vue&type=template&id=a4da15b2"
import script from "./EventModalDocumentsActs.vue?vue&type=script&lang=js"
export * from "./EventModalDocumentsActs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports